import http from "infra/http";
import { useQuery } from "react-query";
import { FormaPagamentoResponse } from "../typings";

function useFormaPagamentos(queryParams?: {
  aceitaRecebimentoOnline?: boolean;
  ativo?: boolean;
}) {
  return useQuery([`/v1/forma-pagamento`, queryParams], async () => {
    const { data } = await http.get<FormaPagamentoResponse[]>(
      `/v1/forma-pagamento`,
      { params: queryParams }
    );

    return data;
  });
}

export default useFormaPagamentos;
